import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c65eeba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-card" }
const _hoisted_2 = {
  id: "about",
  class: "section page-card__content mt--0"
}
const _hoisted_3 = { class: "page-card__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "О застройщике", -1))
const _hoisted_5 = {
  key: 0,
  class: "page-card__content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Награды", -1))
const _hoisted_7 = {
  key: 1,
  class: "page-card__content"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "СК в лицах", -1))
const _hoisted_9 = { class: "items-in-column center gap--5" }
const _hoisted_10 = {
  key: 2,
  id: "documentation",
  class: "section page-card__content"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Документация", -1))
const _hoisted_12 = {
  id: "map",
  class: "page-card__content section page-card__map"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "ЖК на карте", -1))
const _hoisted_14 = {
  id: "allLCD",
  class: "section page-card__content"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Все ЖК строительной компании", -1))
const _hoisted_16 = {
  key: 0,
  class: "page-card__grid-cards"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "center page-card__RC-card" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "page-card__grid-cards" }
const _hoisted_22 = {
  key: 0,
  class: "center mt--20"
}
const _hoisted_23 = {
  key: 3,
  id: "partners",
  class: "page-card__content section"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Партнеры", -1))
const _hoisted_25 = {
  key: 4,
  class: "page-card__content"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Иные застройщики", -1))
const _hoisted_27 = {
  key: 0,
  class: "page-card__grid-cards m-developer-cards"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "pb--10 pt--10 center" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "page-card__grid-cards" }
const _hoisted_33 = { class: "center mt--20" }
const _hoisted_34 = { class: "page-card__aside" }
const _hoisted_35 = { class: "m-font-size mb--10 medium" }
const _hoisted_36 = { class: "mb--5" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Сдано: ", -1))
const _hoisted_38 = { class: "mb--10" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Строится: ", -1))
const _hoisted_40 = { class: "mt--25" }
const _hoisted_41 = { class: "mt--25" }
const _hoisted_42 = { class: "page-card__aside-mobile-card" }
const _hoisted_43 = { class: "page-card__menu" }
const _hoisted_44 = ["href", "onClick"]

import { ActivityButtons, MenuBlock, Partners } from '../CardsComponents';
import {
  DeveloperSmallCard,
  DocumentList,
  MapBlock,
  PhoneButton,
  ResidentialComplexCard,
} from '@/components';
import {
  LoadingMediumDeveloperCard,
  MediumDeveloperCard,
} from '@/components/Cards/MediumCards';
import { DeveloperCardType, SmallCardLSDType } from '@/types';
import LoadingResidentialComplexCard from '@/components/ResidentialComplexCard/LoadingResidentialComplexCard.vue';
import { SmallDeveloperCardType } from '@/types/DeveloperTypes';
import { inject, onMounted, ref } from 'vue';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';
import { useRoute } from 'vue-router';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeveloperCard',
  props: {
    developerCardData: {},
    projects: {},
    projectsLoading: { type: Boolean },
    otherDevelopers: {},
    otherDevelopersLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const menuItems = [
  {
    id: 'about',
    title: 'О застройщике',
  },
  {
    id: 'documentation',
    title: 'Документация',
  },
  {
    id: 'map',
    title: 'ЖК на карте',
  },
  {
    id: 'allLCD',
    title: 'Все ЖК',
  },
  {
    id: 'partners',
    title: 'Партнеры',
  },

  // {
  //   id: 'news',
  //   title: 'Новости',
  // },
];

const visibleProjectsCount = ref(4);
const visibleOtherDevelopersCount = ref(4);

const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;

onMounted(() => {
  const hash = useRoute().hash;

  if (hash) {
    const myEl = document.getElementById(hash.replace('#', ''));

    if (myEl) {
      smoothScroll({
        scrollTo: myEl,
        container: myEl,
        updateHistory: true,
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_swiper = _resolveComponent("base-swiper")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_progress_line = _resolveComponent("base-progress-line")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_menu = _resolveComponent("base-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_image, {
          src: _ctx.developerCardData.logo,
          "border-radius": "",
          class: "page-card__item-img",
          contain: "",
          height: "100%",
          name: "logo",
          width: "100%"
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(DeveloperSmallCard), {
          developer: {
            id: _ctx.developerCardData.id,
            title: _ctx.developerCardData.title,
            logo: _ctx.developerCardData.logo,
            buildingCount: _ctx.developerCardData.buildingCount,
            builtCount: _ctx.developerCardData.builtCount,
            description: _ctx.developerCardData.description,
          },
          "is-full": ""
        }, null, 8, ["developer"])
      ]),
      (_ctx.developerCardData.awards)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_base_card, {
              class: "page-card__swiper-card",
              "full-width-mobile": "",
              "without-mobile-shadow": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_swiper, {
                  slides: _ctx.developerCardData.awards,
                  "space-between": 20,
                  "width-item": 130
                }, {
                  item: _withCtx((itemProps) => [
                    _createElementVNode("a", null, [
                      _createVNode(_component_base_image, {
                        name: String(itemProps),
                        src: itemProps.data,
                        "border-radius": "",
                        contain: "",
                        height: "100",
                        width: "130"
                      }, null, 8, ["name", "src"])
                    ])
                  ]),
                  _: 1
                }, 8, ["slides"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.developerCardData.team)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_base_card, {
              class: "page-card__swiper-card",
              "full-width-mobile": "",
              "without-mobile-shadow": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_swiper, {
                  slides: _ctx.developerCardData.team,
                  "space-between": 20,
                  "width-item": 130
                }, {
                  item: _withCtx((itemProps) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_base_image, {
                        src: itemProps.data.photo,
                        contain: "",
                        height: "100",
                        name: "img",
                        width: "130"
                      }, null, 8, ["src"]),
                      _createElementVNode("span", null, _toDisplayString(itemProps.data['fio']), 1),
                      _createElementVNode("span", null, _toDisplayString(itemProps.data['job']), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["slides"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.developerCardData.documents)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _createVNode(_component_base_card, {
                class: "page-card__documentation",
                "full-width-mobile": "",
                "without-mobile-shadow": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DocumentList), {
                    documents: _ctx.developerCardData.documents
                  }, null, 8, ["documents"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_base_card, {
          "full-width-mobile": "",
          "without-mobile-shadow": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MapBlock), {
              "center-point-map": _ctx.developerCardData.coordinates[0]?.coordinates,
              "result-cards-coordinates": _ctx.developerCardData.coordinates,
              showOfferCard: false,
              class: "mt--20",
              height: "370"
            }, null, 8, ["center-point-map", "result-cards-coordinates"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (_ctx.projectsLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                return _createVNode(LoadingResidentialComplexCard, { key: i })
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_unref(useAppStore)().getWindowWidth() > 600)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_base_swiper, {
                      slides: _ctx.projects,
                      "space-between": 20,
                      "width-item": 240,
                      class: "mt--20 mb--20"
                    }, {
                      item: _withCtx((itemProps) => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(ResidentialComplexCard), {
                              project: itemProps.data,
                              version: "v5"
                            }, null, 8, ["project"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["slides"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects?.slice(0, visibleProjectsCount.value), (project) => {
                        return (_openBlock(), _createBlock(_unref(ResidentialComplexCard), {
                          project: project,
                          version: "v5"
                        }, null, 8, ["project"]))
                      }), 256))
                    ]),
                    (_ctx.projects?.length > visibleProjectsCount.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_base_button, {
                            height: "36",
                            text: "Показать еще",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleProjectsCount.value = visibleProjectsCount.value + 4))
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
      ]),
      (_ctx.developerCardData.partners)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_unref(Partners), {
              partners: _ctx.developerCardData.partners
            }, null, 8, ["partners"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.otherDevelopersLoading || _ctx.otherDevelopers?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            (_ctx.otherDevelopersLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                    return _createVNode(_unref(LoadingMediumDeveloperCard), { key: i })
                  }), 64))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  (_unref(useAppStore)().getWindowWidth() > 600)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(_component_base_swiper, {
                          slides: _ctx.otherDevelopers,
                          "space-between": 20,
                          "width-item": 240,
                          class: "mt--20 mb--20"
                        }, {
                          item: _withCtx((itemProps) => [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_unref(MediumDeveloperCard), {
                                developer: itemProps.data
                              }, null, 8, ["developer"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["slides"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherDevelopers?.slice(
                  0,
                  visibleOtherDevelopersCount.value,
                ), (developer) => {
                            return (_openBlock(), _createBlock(_unref(MediumDeveloperCard), { developer: developer }, null, 8, ["developer"]))
                          }), 256))
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          (_ctx.otherDevelopers?.length > visibleOtherDevelopersCount.value)
                            ? (_openBlock(), _createBlock(_component_base_button, {
                                key: 0,
                                height: "36",
                                text: "Показать еще",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (visibleOtherDevelopersCount.value = visibleOtherDevelopersCount.value + 4))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_card, { class: "page-card__main-info" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.developerCardData.title), 1),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("span", null, _toDisplayString(_ctx.developerCardData.builtCount || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", null, _toDisplayString(_ctx.developerCardData.buildingCount || '-'), 1)
            ]),
            _createVNode(_component_base_progress_line, {
              class: "mb--5",
              name: "Проверка рисков",
              value: "100"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_base_card, null, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuBlock), { "menu-items": menuItems })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_component_base_card, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ActivityButtons), {
              docs: _ctx.developerCardData.documents,
              phone: _ctx.developerCardData.phone
            }, null, 8, ["docs", "phone"])
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, {
      class: "page-card__aside-mobile mb--22",
      to: "#mobileDownMenu"
    }, [
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_unref(PhoneButton), {
          phone: _ctx.developerCardData.phone,
          height: "36"
        }, null, 8, ["phone"]),
        _createVNode(_component_base_menu, null, {
          menuItems: _withCtx((menuItemsProps) => [
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item, i) => {
                return _createElementVNode("div", {
                  key: item.id
                }, [
                  _createElementVNode("a", {
                    href: `#${item.id}`,
                    class: "page-card__menu-item",
                    onClick: ($event: any) => (menuItemsProps.events.handleClick())
                  }, _toDisplayString(item.title), 9, _hoisted_44),
                  (i !== menuItems.length - 1)
                    ? (_openBlock(), _createBlock(_component_base_divider, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              }), 64))
            ])
          ]),
          _: 1
        })
      ])
    ]))
  ]))
}
}

})